import { useNavigate } from 'react-router';
import { LoginForm } from './components/login-form';
import { Routes } from 'business/router/constants';
import { Content } from 'ui/components/content';

export const LoginPage = () => {
  const navigate = useNavigate();

  return (
    <Content>
      <LoginForm onSuccess={() => navigate(Routes.App)} />
    </Content>
  );
};
